// extracted by mini-css-extract-plugin
export default {"containerSlider":"slider-items_containerSlider__0hHj+","item":"slider-items_item__0-uay"};